// 页面元数据配置
const PAGE_META = {
  home: {
    title: '职考助手 - 智能规划备考路径，成就你的职业梦想',
    description: '职考助手 - 智能规划备考路径，成就你的职业梦想'
  },
  study: {
    title: '知识卡',
    description: '知识卡 - 快速解锁你的职考通过率'
  },
  tiku: {
    title: '题库分类',
    description: '题库分类 - 快速解锁你的职考通过率'
  },
  exam: {
    title: '系统介绍',
    description: '系统介绍 - 快速解锁你的职考通过率'
  },
  cate: {
    title: '试题查询',
    description: '试题查询 - 快速解锁你的职考通过率'
  }
};

export const updateMetaTags = (pageName) => {
  const meta = PAGE_META[pageName] || PAGE_META.home;
  
  // 更新 title
  document.title = meta.title;
  
  // 更新 description
  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', meta.description);
  } else {
    const newMeta = document.createElement('meta');
    newMeta.name = 'description';
    newMeta.content = meta.description;
    document.head.appendChild(newMeta);
  }
}; 